<header class="mobile_header">
    <span *ngIf="!hideBack" (click)="goBack.emit(true)" class="back_btn grey">
        <img src="assets/images/back_arrow.svg" alt="">
    </span>
    <span *ngIf="!hideBack" (click)="goBack.emit(true)" class="back_btn white">
        <img src="assets/images/back_arrow-white.svg" alt="">
    </span>
    <h3 class="text">
        {{headerTitle}}
    </h3>
    <span *ngIf="showSettings" class="right-btn white">
        <a [routerLink]="['PROFILE_SETTINGS'|absolutePath]" class="setting-icon"><img src="assets/images/Settings.png"
                alt=""></a>
    </span>
    <span *ngIf="showMenuButton" class="right-btn white">
        <!-- <a [routerLink]="['HOME'|absolutePath]" class="menu-icon"><img src="assets/images/Menu_Icon.png" alt=""></a> -->
        <a (click)="onExploreMenu()"><img src="assets/images/Menu_Icon.png" alt=""></a>
    </span>
    <div class="save-btn" *ngIf="showSaveButton">
        <button (click)="onSave.emit()" type="submit" class="outline-btn">{{buttonText?buttonText:'Save'}}</button>
    </div>

    <div *ngIf="showDots" class="save-btn">

        <button style="background: transparent;color: white;" mat-icon-button [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button (click)="emailUs()" mat-menu-item>
                <span>Email Us</span>
            </button>
            <button *ngIf="showMenu" (click)="onCancel.emit()" mat-menu-item>
                <span>Cancel</span>
            </button>


        </mat-menu>
    </div>
</header>